import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FeatureFlagService } from '../../features/feature-flags/feature-flag.service';

export const featureFlagGuard = (key: string): CanActivateFn => () => {
  const featureFlagService = inject(FeatureFlagService);
  const router = inject(Router);

  return featureFlagService.isEnabled(key) ? true : router.parseUrl('/');
};
